export default {
    name: 'ILayoutContent'
};
